import {SxProps, Theme} from '@mui/material';
import {pillShapePhoneSx} from 'src/components/common/pillFit.sx';
import theme from '../../../../theme';

export const locationItemCardSx = {
    menuBtn: {
        width: '100%',
    },
    menuBtnText: {
        width: '100%',
        textAlign: 'start',
        fontSize: theme.spacing(14 / 8),
        fontWeight: 400,
        color: theme.palette.neutral[400],
    },
    iconBtn: {
        width: theme.spacing(20 / 8),
        height: theme.spacing(20 / 8),
        backgroundColor: 'transparent',
    },
    popover: {
        '& .MuiPaper-root': {
            maxWidth: theme.spacing(200 / 8),
            width: '100%',
            p: 1,
        },
    },
};

/** The title is the location's name and the way into it: a link that reads as the title. */
export const nameLinkSx: SxProps<Theme> = {
    color: 'inherit',
    textDecoration: 'none',
};

/** A count, as a pill - the icon says what is being counted, so the number needs no label. */
export const countPillSx: SxProps<Theme> = {
    ...pillShapePhoneSx,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    color: theme.palette.neutral[600],
    backgroundColor: theme.palette.neutral[50],
    border: `1px solid ${theme.palette.neutral[200]}`,
    '& svg': {
        width: 12,
        height: 12,
    },
};

/** A fact whose value carries a control. A span, because a fact's value is drawn inside a paragraph. */
export const factWithActionSx: SxProps<Theme> = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
};
